exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icons-container[data-v-279234be]{margin:10px 20px 0;overflow:hidden}.icons-container .icon-item[data-v-279234be]{margin:20px;height:85px;text-align:center;width:100px;float:left;font-size:30px;color:#24292e;cursor:pointer}.icons-container span[data-v-279234be]{display:block;font-size:16px;margin-top:10px}.icons-container .disabled[data-v-279234be]{pointer-events:none}\n", ""]);

// exports
